import { ToastManagerRepository } from "@core/domain/repositories/toast-manager.repository";
import { RecuperableModelError } from "@iot-platform/core";
import type { AlertRepository } from "@station/domain/repositories/alert.repository";
import { stationsTypes } from "@station/station-types.di";
import { inject, injectable } from "inversify";

@injectable()
export class PredefinedAlertUpdateUseCase {
    constructor(
        @inject(stationsTypes.repositories.AlertRepository)
        private readonly alertRepository: AlertRepository,
    ) {}

    async execute(
        stationId: string,
        predefinedAlert: number[],
    ): Promise<boolean> {
        const editResult = await this.alertRepository.updatePredefinedAlert(
            stationId,
            predefinedAlert,
        );

        return editResult.match(
            () => true,
            (error) => {
                if (error instanceof RecuperableModelError) {
                    ToastManagerRepository.warning(error.message);

                    return false;
                }

                ToastManagerRepository.error(error.message);

                return false;
            },
        );
    }
}
